<section class="main-container col2-left-layout bounceInUp animated">
  <div class="container">

    <!-- ============ SEARCH RESULTS ============ -->
    <ng-container *ngIf="isSearch; else marketplaceContent">
      <div class="row search-layout">

        <!-- LEFT SIDEBAR -->
        <aside class="col-lg-3 col-md-4 search-sidebar">
          <div class="search-sidebar-panel">

            <!-- Price filter -->
            <div class="filter-section">
              <h4 class="filter-title" (click)="filtersExpanded.price = !filtersExpanded.price">
                {{ 'search.filters.price' | translate }}
                <i class="fa" [class.fa-chevron-up]="filtersExpanded.price" [class.fa-chevron-down]="!filtersExpanded.price"></i>
              </h4>
              <div class="filter-content" [class.collapsed]="!filtersExpanded.price">
                <div class="price-inputs">
                  <input type="number" class="form-control" [(ngModel)]="minPrice" [placeholder]="'search.filters.min_price' | translate" (change)="applyPriceFilter()" (input)="clearPriceError()" min="0">
                  <input type="number" class="form-control" [(ngModel)]="maxPrice" [placeholder]="'search.filters.max_price' | translate" (change)="applyPriceFilter()" (input)="clearPriceError()" min="0">
                </div>
                <div class="price-error" *ngIf="priceError">
                  <i class="fa fa-exclamation-circle"></i> {{ priceError | translate }}
                </div>
              </div>
            </div>

            <!-- Categories filter -->
            <div class="filter-section">
              <h4 class="filter-title" (click)="filtersExpanded.categories = !filtersExpanded.categories">
                {{ 'search.filters.categories' | translate }}
                <i class="fa" [class.fa-chevron-up]="filtersExpanded.categories" [class.fa-chevron-down]="!filtersExpanded.categories"></i>
              </h4>
              <div class="filter-content" [class.collapsed]="!filtersExpanded.categories">
                <ul class="category-filter-list">
                  <li>
                    <label class="filter-item">
                      <input type="radio" name="category-filter" [checked]="selectedCategoryId === null" (change)="selectCategory(null)">
                      <span>{{ 'search.filters.all_categories' | translate }}</span>
                    </label>
                  </li>
                  <li *ngFor="let category of categoriesWithResults">
                    <label class="filter-item">
                      <input type="radio" name="category-filter" [checked]="selectedCategoryId === category.id" (change)="selectCategory(category.id)">
                      <span>{{ lang === 'fr' ? category.nameFr : category.name }}</span>
                      <span class="count">({{ getCategoryCount(category.id) }})</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </aside>

        <!-- RIGHT CONTENT -->
        <div class="col-lg-9 col-md-8 search-content">

          <!-- Search heading -->
          <div class="search-heading">
            <h2 class="search-term">"{{ q }}" <span class="product-count">{{ 'search.products_count' | translate: { count: config?.totalItems || 0 } }}</span></h2>

            <div class="sort-wrapper">
              <label>{{ 'search.sort_by' | translate }}</label>
              <select class="form-select"
                      [ngModel]="sortBy"
                      (ngModelChange)="onSortChange($event)">
                <option value="relevance">{{ 'search.relevance' | translate }}</option>
                <option value="priceAsc">{{ 'search.price_asc' | translate }}</option>
                <option value="priceDesc">{{ 'search.price_desc' | translate }}</option>
              </select>
            </div>
          </div>

          <!-- Loading -->
          <div class="pro-coloumn" *ngIf="loading">
            <p style="text-align: center">{{ 'common.loading' | translate }} ...</p>
          </div>

          <!-- Results -->
          <ng-container *ngIf="!loading">
            <ng-template #products_not_found>
              <div class="empty-state">
                <div class="empty-icon">
                  <i class="fa fa-box-open"></i>
                </div>
                <h3 class="empty-title">{{ 'products.no_search_results' | translate: { query: q } }}</h3>
                <p class="empty-subtitle">{{ 'products.no_results_subtitle' | translate }}</p>
              </div>
              <div class="recommended-section" *ngIf="recommendedOffers.length > 0">
                <h4 class="recommended-title">{{ 'products.you_might_like' | translate }}</h4>
                <div class="product-grid">
                  <div class="product-card" *ngFor="let offer of recommendedOffers">
                    <a [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]"
                      class="card-image-wrapper">
                      <img class="card-image" [defaultImage]="'/assets/images/default.jpg'"
                        [lazyLoad]="getImageSrc(offer)" [alt]="offer.product.name" />
                      <div class="discount-badge" *ngIf="isInPromotion(offer)">-{{ offer.percentDiscount }}%</div>
                      <div class="stock-badge" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">{{ 'product.in_stock' | translate }}
                      </div>
                      <ng-template #outOfStock>
                        <div class="stock-badge out-of-stock">{{ 'product.out_of_stock' | translate }}</div>
                      </ng-template>
                    </a>
                    <div class="card-content">
                      <a [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]"
                        class="product-name">
                        {{ lang === 'fr' ? offer.product.productNameFr : offer.product.productName }}
                      </a>
                      <p class="product-desc">{{ stripHtml(offer.description) }}</p>
                      <div class="product-price">
                        <span class="current-price">{{ getOfferPrice(offer) | number }} {{ offer.currency | uppercase }}</span>
                        <span class="old-price" *ngIf="isInPromotion(offer)">{{ offer.price | number }} {{ offer.currency | uppercase }}</span>
                        <span class="unit-price"> / {{ lang === 'fr' ? offer.measurementunit.descriptionFr : offer.measurementunit.description }}</span>
                      </div>
                      <div class="product-actions">
                        <button *ngIf="!isOfferInCart(offer) && offer.qty > 0 && !offer.availableDate" class="btn-add"
                          (click)="$event.stopPropagation(); addToCart(offer)">
                          <i class="fa fa-shopping-cart"></i>
                          <span>{{ 'common.add_to_cart' | translate }}</span>
                        </button>
                        <button class="btn-like" (click)="$event.stopPropagation(); addToWishlist(offer.id)">
                          <i class="fa fa-heart"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>

            <article *ngIf="offers?.length > 0; else products_not_found">
              <div class="product-grid">
                <div class="product-card" *ngFor="let offer of offers | paginate: config">
                  <a [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]"
                    class="card-image-wrapper">
                    <img class="card-image" [defaultImage]="'/assets/images/default.jpg'" [lazyLoad]="getImageSrc(offer)"
                      [alt]="offer.product.name" />
                    <div class="discount-badge" *ngIf="isInPromotion(offer)">-{{ offer.percentDiscount }}%</div>
                    <div class="stock-badge" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">{{ 'product.in_stock' | translate }}
                    </div>
                    <ng-template #outOfStock>
                      <div class="stock-badge out-of-stock">{{ 'product.out_of_stock' | translate }}</div>
                    </ng-template>
                  </a>
                  <div class="card-content">
                    <a [routerLink]="['/products', offer.product.slug == null ? offer.product.name : offer.product.slug, offer.id]"
                      class="product-name">
                      {{ lang === 'fr' ? offer.product.productNameFr : offer.product.productName }}
                    </a>
                    <p class="product-desc">{{ stripHtml(offer.description) }}</p>
                    <div class="product-price">
                      <span class="current-price">{{ getOfferPrice(offer) | number }} {{ offer.currency | uppercase }}</span>
                      <span class="old-price" *ngIf="isInPromotion(offer)">{{ offer.price | number }} {{ offer.currency | uppercase }}</span>
                      <span class="unit-price"> / {{ lang === 'fr' ? offer.measurementunit.descriptionFr : offer.measurementunit.description }}</span>
                    </div>
<div class="product-actions">
                        <button *ngIf="!isOfferInCart(offer) && offer.qty > 0 && !offer.availableDate" class="btn-add"
                          (click)="$event.stopPropagation(); addToCart(offer)">
                          <i class="fa fa-shopping-cart"></i>
                          <span>{{ 'common.add_to_cart' | translate }}</span>
                        </button>
                      <button class="btn-like" (click)="$event.stopPropagation(); addToWishlist(offer.id)">
                        <i class="fa fa-heart"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="toolbar" *ngIf="config?.totalOfPage > 1">
                <div class="pager">
                  <pagination-controls class="pages" maxSize="5" [previousLabel]="'common.previous' | translate"
                    [nextLabel]="'common.next' | translate" autoHide="true" id="listing"
                    (pageChange)="pageChange($event)">
                  </pagination-controls>
                </div>
              </div>
            </article>
          </ng-container>

        </div>
      </div>
    </ng-container>

    <!-- ============ MARKETPLACE CONTENT ============ -->
    <ng-template #marketplaceContent>
      <!-- Category sidebar + promotional slider -->
      <app-new-slider></app-new-slider>

      <!-- Category slider -->
      <app-category-slider></app-category-slider>

      <!-- Best Selling -->
      <app-taxonomy-offers [taxonomyId]="1" [title]="'common.best_selling' | translate"></app-taxonomy-offers>

      <app-ad-content [bannerGroup]="'INNER_PAGE_TOP'"></app-ad-content>

      <!-- Featured Products -->
      <app-taxonomy-offers [taxonomyId]="2" [title]="'common.featured_products' | translate"></app-taxonomy-offers>

      <app-ad-content [bannerGroup]="'INNER_PAGE_MIDDLE'"></app-ad-content>

      <!-- Recommended Products -->
      <app-taxonomy-offers [taxonomyId]="3" [title]="'common.recommended_products' | translate"></app-taxonomy-offers>

      <app-ad-content [bannerGroup]="'INNER_PAGE_BOTTOM'"></app-ad-content>
    </ng-template>

  </div>
</section>
